import TableSynchronization from './component/TableSynchronization'

export default TableSynchronization
